import { contentType2Extension } from "./getMediaInfo";
export function toBase64(img: File) {
    return new Promise<string>(resolve => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(reader.result as string));
        reader.readAsDataURL(img);
    })
}

export function blob2File(blob:Blob, fileName?:string) {
    const now = Date.now();
    if (!fileName) {
        const ext = contentType2Extension(blob.type);
        fileName = !ext ? `${now}` : `${now}.${ext}`;
    }
    return new File([blob], fileName, {lastModified:now, type:blob.type});
}
function base64MimeType(encoded:string) {
  var result = null;

  if (typeof encoded !== 'string') {
    return result;
  }

  var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

  if (mime && mime.length) {
    result = mime[1];
  }

  return result;
}
export function base64toBlob(base64Data:string) {
    var sliceSize = 1024;
    var contentType = base64MimeType(base64Data);
    if(contentType){
        base64Data = base64Data.replace("data:" + contentType + ";base64,", '');
    }
    else{
        contentType = "";
    }
    var byteCharacters = window.atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

